// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1869":"75e9487562a697a7674f","3198":"6ef92522494848c51f8e"}[chunkId] + ".css";
};